import React, { Component, Fragment } from 'react'
import * as Sentry from '@sentry/browser'

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: '' };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error: error };
    }
    componentDidCatch(error, errorInfo) {
        console.log("Error", error)
        console.log("Error info", errorInfo)
        Sentry.captureException(error, { extraInfo: errorInfo });
    }
    render() {
        if (this.state.hasError) {
            return <Fragment>
                <h1>Ein Fehler ist aufgetreten</h1>
                <p>Ich habe die Fehlermeldung per Mail bekommen und bin schon an der Lösung dran.</p>
                <p><a href={window.location.href}>Seite neu laden</a></p>
            </Fragment>;
        }
        return this.props.children;
    }
}
